import React, { useEffect, useState } from 'react';
import { Copy, Phone, Headset, Clock } from 'lucide-react';
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import TransferBanner from './TransferBanner';

const TopBar: React.FC = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const formattedDate = now.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const formattedTime = now.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const handleCopy = (text: string, type: string) => {
    navigator.clipboard.writeText(text);
    // Hier könnte ein Toast kommen
  };

  return (
    <div className="bg-topbar text-topbar-foreground py-1">
      <div className="flex justify-between items-center w-full px-4 text-xs">
        <div className="flex items-center gap-4">
          {/* Telefonnummer */}
          <div className="group flex items-center relative">
            <a 
              href="tel:+4922838759280"
              className="flex items-center text-inherit no-underline pr-6 hover:text-topbar-foreground"
            >
              <Phone className="h-3 w-3 mr-1.5" />
              <span className="hidden sm:inline">0228 / 387 592 80</span>
            </a>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="absolute right-0 h-5 w-5 opacity-0 group-hover:opacity-100 transition-all duration-200 bg-topbar-foreground/10 hover:bg-topbar-foreground/20 text-topbar-foreground rounded-sm"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCopy('0228 / 387 592 80', 'Telefonnummer');
                    }}
                  >
                    <Copy className="h-3 w-3" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Nummer kopieren</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>

          {/* Fernwartung / Support */}
          <a 
            href="https://www.timeglobe.de/support/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-inherit no-underline hover:text-topbar-foreground"
          >
            <Headset className="h-3 w-3 mr-1.5" />
            <span className="hidden sm:inline">Fernwartung</span>
          </a>
        </div>

        {/* Datum & Uhrzeit */}
        <div className="flex items-center text-topbar-foreground opacity-80">
          <Clock className="h-3 w-3 mr-1.5" />
          <span className="tabular-nums">
            {formattedDate}, {formattedTime}
          </span>
        </div>
      </div>
      {/* Live phone transfers (call.transfer) — renders nothing while none is running. */}
      <TransferBanner />
    </div>
  );
};

export default TopBar;
